/* Theme-mode toggle. The pre-paint default (light when unset) lives in
   layout/theme.liquid's inline script; this only flips and persists.
   Pages with data-ed-theme-lock="light" stay light (CBS header fix); pages with
   data-ed-theme-lock="dark" stay dark (the timeline page's black canvas). Either
   lock hides the control — .header__icon { display:flex } beats [hidden].
   A lock is per-page and is deliberately NOT written to localStorage, so the
   visitor's own preference survives once they navigate away. */
(function () {
  var lock = document.documentElement.getAttribute('data-ed-theme-lock');
  var locked = lock === 'light' || lock === 'dark';
  if (locked) {
    /* Belt-and-suspenders: pin the locked mode if anything else changed it. */
    if (lock === 'dark') {
      document.documentElement.setAttribute('data-ed-theme', 'dark');
    } else {
      document.documentElement.removeAttribute('data-ed-theme');
    }
  }
  document.querySelectorAll('[data-ed-theme-toggle]').forEach(function (btn) {
    if (locked) {
      btn.setAttribute('aria-pressed', lock === 'dark' ? 'true' : 'false');
      btn.setAttribute('hidden', '');
      btn.setAttribute('aria-hidden', 'true');
      btn.setAttribute('tabindex', '-1');
      btn.style.setProperty('display', 'none', 'important');
      return;
    }
    btn.setAttribute(
      'aria-pressed',
      document.documentElement.getAttribute('data-ed-theme') === 'dark' ? 'true' : 'false'
    );
    btn.addEventListener('click', function () {
      if (document.documentElement.getAttribute('data-ed-theme-lock')) return;
      var next = document.documentElement.getAttribute('data-ed-theme') === 'dark' ? 'light' : 'dark';
      if (next === 'dark') {
        document.documentElement.setAttribute('data-ed-theme', 'dark');
      } else {
        /* Absence of the attribute IS light mode (today's stylesheet untouched);
           a 'light' value is stored so the pre-paint script respects it. */
        document.documentElement.removeAttribute('data-ed-theme');
      }
      try {
        localStorage.setItem('ed-theme', next);
      } catch (e) {
        /* Private browsing: the toggle still works for this page view. */
      }
      btn.setAttribute('aria-pressed', next === 'dark' ? 'true' : 'false');
      document.dispatchEvent(new CustomEvent('ed:theme-change', { detail: { theme: next } }));
    });
  });
})();
